import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import divShowAndHideReducer from './div-show-and-hide/div-show-and-hide.reducer';
import onBoardingReducer from './on-boarding/on-boarding.reducer';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['onBoarding']
}

const rootReducer = combineReducers({
    divShowAndhide: divShowAndHideReducer,
    onBoarding:onBoardingReducer
})


export default persistReducer(persistConfig, rootReducer);